import { FormEvent, useEffect, useState } from "react";

import LoginPageView from "./LoginPageView";

async function loadSupabaseClient() {
  const module = await import("../lib/supabase");
  return module.getSupabaseClient();
}

export default function LoginPage(): JSX.Element {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState<string | null>(null);

  useEffect(() => {
    let active = true;

    async function checkSession(): Promise<void> {
      try {
        if (process.env.NODE_ENV === "test") return;

        const supabase = await loadSupabaseClient();
        const { data, error } = await supabase.auth.getSession();
        if (!active) return;
        if (!error && data?.session) {
          window.location.assign("/");
        }
      } catch {
        // ignore and keep form visible
      }
    }

    void checkSession();

    return () => {
      active = false;
    };
  }, []);

  async function onSubmit(event: FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault();
    if (loading) return;

    setErrorText(null);
    setLoading(true);

    try {
      const supabase = await loadSupabaseClient();
      const { error } = await supabase.auth.signInWithPassword({
        email: email.trim(),
        password,
      });

      if (error) {
        setErrorText(error.message);
        return;
      }

      window.location.assign("/");
    } catch (error) {
      setErrorText(error instanceof Error ? error.message : "Sign-in failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <LoginPageView
      email={email}
      password={password}
      loading={loading}
      errorText={errorText}
      onEmailChange={setEmail}
      onPasswordChange={setPassword}
      onSubmit={onSubmit}
    />
  );
}
